import { render, staticRenderFns } from "./WidgetBestProducts.vue?vue&type=template&id=93f87ade"
import script from "./WidgetBestProducts.vue?vue&type=script&lang=js"
export * from "./WidgetBestProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports